import React, {useEffect} from 'react';
import {withRouter} from "react-router-dom";
import {withToastManager} from "react-toast-notifications";

function GoogleButton(props) {
    useEffect(() => {
        if (window.google) {
            window.google.accounts.id.initialize({
                client_id: window.bubblyWebsiteConfig.GOOGLE_APP_ID,
                auto_select: false,
                callback: handleGoogleCredentialResponse
            });
            window.google.accounts.id.renderButton(
                document.getElementById("googleLoginDiv"),
                { size: "small", text: "signin" }
            );
        }
    }, [window.google]);

    function getGoogleErrorMessageByCode(code) {
        let errorMessage = "";
        switch (code) {
            case "idpiframe_initialization_failed":
                errorMessage = "Error with Google login, failed to initialize Google module due to unauthorized domain app!";
                break;
            case "popup_closed_by_user":
                errorMessage = "Error with Google login, pop-up closed by user!";
                break;
            case "access_denied":
                errorMessage = "Error with Google login, permissions denied by user!";
                break;
            case "immediate_failed":
                errorMessage = "Error occurred while trying to login user using Google!";
                break;
            default:
                errorMessage = "Unknown Google login error, please contact Questia!";
                break;
        }
        return errorMessage;
    }

    const handleGoogleAuth = () => {
        let googleLoginContainerDiv = document.getElementById("googleLoginDiv").firstElementChild;
        if (googleLoginContainerDiv) {
            let googleLoginContainerDivSecondFirstChild = googleLoginContainerDiv.firstElementChild.firstElementChild;
            if (googleLoginContainerDivSecondFirstChild && googleLoginContainerDivSecondFirstChild.children[1]) {
                /* Regular Google Login button div structure */
                googleLoginContainerDivSecondFirstChild.children[1].click();
            }
            else {
                /* Alternative Google Login button div structure */
                if (googleLoginContainerDiv.children[1] && googleLoginContainerDiv.children[1].children[1])
                    googleLoginContainerDiv.children[1].children[1].click();
            }
        }
    }

    function handleLoginFailure(data) {
        const {toastManager} = props;
        const errorMessage = typeof data.error === 'undefined' ?  'Error occurred while trying to login user using Google!' : getGoogleErrorMessageByCode(data.error);
        toastManager.add(errorMessage, {
            appearance: 'error'
        });
    }

    const handleGoogleCredentialResponse = (response) => {
        var goToLink = "/social-auth?state=google";
        props.history.push(goToLink, {googleJwt: response.credential});
    }

    return (<>
        <div id="googleLoginDiv" style={{display: "none"}}> </div>
        <a href="javascript:void(0);" onClick={handleGoogleAuth}> <img src="assets/img/login_page/google.png" alt=""/> </a>
    </>);
}

export default withToastManager(withRouter(GoogleButton));